import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import 'jquery-modal';

import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

const application = Application.start();
const context = require.context('./controllers', true, /\.js$/);
application.load(definitionsFromContext(context));
